const SESSION_KEY = "tp_session_id";

function generateSessionId(): string {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
}

function getSessionId(): string {
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = generateSessionId();
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

function getUTMParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    utmSource: params.get("utm_source") || undefined,
    utmMedium: params.get("utm_medium") || undefined,
    utmCampaign: params.get("utm_campaign") || undefined,
    utmTerm: params.get("utm_term") || undefined,
    utmContent: params.get("utm_content") || undefined,
  };
}

let sessionInitialized = false;

export async function initSession() {
  if (sessionInitialized) return;
  sessionInitialized = true;

  const sessionId = getSessionId();
  const utm = getUTMParams();

  try {
    await fetch("/api/analytics/session", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        sessionId,
        referrer: document.referrer || null,
        landingPage: window.location.pathname,
        ...utm,
      }),
      credentials: "include",
    });
  } catch (e) {
    console.debug("Analytics session init failed:", e);
  }
}

export async function trackInternalPageView(path: string) {
  const sessionId = getSessionId();

  try {
    await fetch("/api/analytics/pageview", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        sessionId,
        path,
        referrer: document.referrer || null,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
      }),
      credentials: "include",
    });
  } catch (e) {
    console.debug("Analytics pageview failed:", e);
  }
}

export async function trackInternalEvent(
  eventName: string,
  category?: string,
  label?: string,
  value?: number,
  metadata?: Record<string, any>,
) {
  const sessionId = getSessionId();

  try {
    await fetch("/api/analytics/event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        sessionId,
        eventName,
        category,
        label,
        value,
        path: window.location.pathname,
        metadata,
      }),
      credentials: "include",
    });
  } catch (e) {
    console.debug("Analytics event failed:", e);
  }
}
